module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-70.756a7cdb.svg";